import { EquipmentMaintenance } from 'types/EquipmentMaintenance';
import { groupByInterval, mapToInterval } from './utils';

export default function getMaintenanceIntervals(
  schedules: EquipmentMaintenance[] = [],
) {
  const grouped = groupByInterval(schedules);
  const intervals = mapToInterval(grouped);

  intervals.sort((a, b) => {
    const primaryDiff = a.sortOrderPrimary - b.sortOrderPrimary;
    if (primaryDiff !== 0) return primaryDiff;
    return (a.sortOrderSecondary ?? 0) - (b.sortOrderSecondary ?? 0);
  });

  return intervals;
}
